import { type Directive, ref } from 'vue'
import { defineStore } from 'pinia'
import type { TooltipFragment } from '@/graphql/api'

type TooltipCustom = {
    type: 'tooltip-custom'
    id: Symbol
}

export const isCustomTooltip = (
    tooltip: TooltipFragment | TooltipCustom | null
): tooltip is TooltipCustom =>
    !!tooltip && 'type' in tooltip && tooltip.type === 'tooltip-custom'

export const useTooltipStore = defineStore('tooltip', () => {
    const tooltip = ref<TooltipFragment | TooltipCustom | null>(null)
    const triggerElement = ref<HTMLElement | null>(null)

    const open = (
        t: TooltipFragment | TooltipCustom,
        triggerEl: HTMLElement
    ) => {
        tooltip.value = t
        triggerElement.value = triggerEl
    }

    const close = () => {
        tooltip.value = null
        triggerElement.value = null
    }

    return {
        tooltip,
        triggerElement,
        open,
        close,
    }
})

export const tooltipDirective: Directive<any, TooltipFragment> = (
    el: HTMLElement,
    binding
) => {
    const tooltip = binding.value
    // eslint-disable-next-line vue-composable/composable-placement
    const tooltipStore = useTooltipStore()

    el.addEventListener('click', (e) => {
        e.stopPropagation()
        e.preventDefault()

        if (
            !isCustomTooltip(tooltipStore.tooltip) &&
            tooltipStore.tooltip?.content === tooltip.content &&
            tooltipStore.tooltip?.title === tooltip.title
        ) {
            tooltipStore.close()
        } else {
            tooltipStore.open(tooltip, el)
        }
    })
}
